export default "__VITE_ASSET__CzRUxkXC__"